export default {"src":"/_next/static/media/logo-mobile.8cdd0cd3.svg","height":487,"width":222,"blurWidth":0,"blurHeight":0};